<template>
  <Toast/>

  <ConfirmDialog group="delete">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-5 bg-surface-0 dark:bg-surface-700 rounded-md">
        <div
            class="rounded-full bg-red-500 dark:bg-red-400 text-surface-0 dark:text-surface-900 inline-flex justify-center items-center h-[6rem] w-[6rem] -mt-[3rem]">
          <IconAlertTriangleFilled aria-hidden="true" class="h-10 w-10 text-surface-50"/>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4 text-surface-900 dark:text-surface-0">{{
            message.header
          }}</span>
        <p class="mb-0 text-surface-800 dark:text-surface-100">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-4">
          <Button data-cy="delete-button" :label="message.acceptLabel ?? 'Delete'" class="w-[8rem]" severity="danger"
                  @click="acceptCallback"></Button>
          <Button :label="message.rejectLabel ?? 'Cancel'" class="w-[8rem]" outlined severity="secondary"
                  @click="rejectCallback"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <ConfirmDialog group="save">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-5 bg-surface-0 dark:bg-surface-700 rounded-md">
        <div
            class="rounded-full bg-blue-500 dark:bg-blue-400 text-surface-0 dark:text-surface-900 inline-flex justify-center items-center h-[6rem] w-[6rem] -mt-[3rem]">
          <IconDeviceFloppy aria-hidden="true" class="h-10 w-10 text-surface-50"/>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4 text-surface-900 dark:text-surface-0">{{
            message.header
          }}</span>
        <p class="mb-0 text-surface-800 dark:text-surface-100">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-4">
          <Button :label="message.acceptLabel ?? 'Save'" class="w-[8rem]" severity="info"
                  @click="acceptCallback"></Button>
          <Button :label="message.rejectLabel ?? 'Cancel'" class="w-[8rem]" outlined severity="secondary"
                  @click="rejectCallback"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <ConfirmDialog group="confirm">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-5 bg-surface-0 dark:bg-surface-700 rounded-md">
        <div
            class="rounded-full bg-green-500 dark:bg-green-400 text-surface-0 dark:text-surface-900 inline-flex justify-center items-center h-[6rem] w-[6rem] -mt-[3rem]">
          <IconAlertTriangleFilled aria-hidden="true" class="h-10 w-10 text-surface-50"/>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4 text-surface-900 dark:text-surface-0">{{
            message.header
          }}</span>
        <p class="text-center mb-0 text-surface-800 dark:text-surface-100">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-4">
          <Button :label="message.acceptLabel ?? 'Confirm'" class="w-[8rem]" severity="success"
                  @click="acceptCallback"></Button>
          <Button :label="message.rejectLabel ?? 'Cancel'" class="w-[8rem]" outlined severity="info"
                  @click="rejectCallback"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <DynamicDialog/>
  <router-view></router-view>
</template>

<script>
import Toast from "primevue/toast";
import {IconAlertTriangleFilled, IconDeviceFloppy} from "@tabler/icons-vue";
import ConfirmDialog from "primevue/confirmdialog";
import DynamicDialog from 'primevue/dynamicdialog';

export default {
  name: "App",
  components: {ConfirmDialog, DynamicDialog, IconAlertTriangleFilled, IconDeviceFloppy, Toast},
  mounted() {
    this.$primevue.config.ripple = true;
  },
}
</script>
